/**
 * 出货订单管理 分发路由
 * @author FJJ
 * @version 1.0
 * @Time 2022.01.22
 *
 * */
import React,{PureComponent} from 'react'
import {Switch,Route, Redirect} from 'react-router-dom'

import EstimatedShippingOrderList from "@pages/ShipperManagement/EstimatedShippingOrder/List"; //预计出货订单
import EstimatedShippingOrderDetail from "@pages/ShipperManagement/EstimatedShippingOrder/Details/Details"; //预计出货订单详情
// import EstimatedShippingOrderBill from "@pages/ShipperManagement/EstimatedShippingOrder/Bill/Bill"; //单据管理
import EstimatedShippingOrderBill from "@pages/ShipperManagement/EstimatedShippingOrder/Bill/Index"; //单据管理
import CheckQualityPictures from "@pages/ShipperManagement/EstimatedShippingOrder/CheckQualityPictures/CheckQualityPictures";// 检查质检确认

import ShippingOrderList from "@pages/ShipperManagement/ShippedOrder/List"; //已出货订单
import ShippingOrderDetail from "@pages/ShipperManagement/ShippedOrder/Details/Details"; //已出货订单详情
class ShipperRouter extends PureComponent{
    render() {
        return (
            <Switch>
                <Route path="/shipperManagement/estimatedShippingOrder/list" component={EstimatedShippingOrderList} />
                <Route path="/shipperManagement/estimatedShippingOrder/detail" component={EstimatedShippingOrderDetail} />
                <Route path="/shipperManagement/estimatedShippingOrder/bill" component={EstimatedShippingOrderBill} />

                <Route path="/shipperManagement/estimatedShippingOrder" render={(props) => <Redirect to="/shipperManagement/estimatedShippingOrder/list" />} />

                <Route path="/shipperManagement/shippingOrder/list" component={ShippingOrderList} />
                <Route path="/shipperManagement/shippingOrder/detail" component={ShippingOrderDetail} />
                <Route path="/shipperManagement/shippingOrder" render={(props) => <Redirect to="/shipperManagement/shippingOrder/list" />} />


                <Route path="/shipperManagement/checkQualityPictures" component={CheckQualityPictures} />
                <Route path="/*" render={(props) => <Redirect to="/shipperManagement/estimatedShippingOrder/list" />} />
            </Switch>
        );
    }
};

export default ShipperRouter;
